module.exports = __webpack_public_path__ + "static/media/shuffle.5b851589.svg";